// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-container[data-v-a7931654] {\n  background-color: #e8eef1;\n  border-radius: 8px;\n}", ""]);
// Exports
module.exports = exports;
